// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3ZWgZ","overflowing":"ReadFullNote_overflowing__2zxny"};